import React, { useMemo } from 'react';
import { useOnboarding } from '../../contexts/OnboardingContext';
import toast from 'react-hot-toast';
import { Toaster } from '../common';
import { Tooltip } from '@radix-ui/themes';
import { Copy, EditPencil } from 'iconoir-react';

const EditAnswerOptions = ({
  answer,
  questionId,
}: {
  answer: string;
  questionId: string;
}) => {
  const { questions, setSelected, setAnswer } = useOnboarding();

  const currentQuestion = useMemo(
    () => questions.find(question => question.id === questionId),
    [questions, questionId]
  );

  const handleCopyAnswer = (answer: string) => {
    if (currentQuestion?.code === 'resume_linkedin_bio') {
      const bioResponse: Record<string, string> = JSON.parse(answer as string);
      const bio = Object.values(bioResponse).join(' ');
      navigator.clipboard.writeText(bio);
    } else {
      navigator.clipboard.writeText(answer);
    }
    toast.custom(t => (
      <Toaster message='Answer copied to clipboard' type='success' id={t.id} />
    ));
  };

  const handleEditAnswer = (questionId: string, answer: string) => {
    setSelected(questionId);
    setAnswer(answer);
  };

  return (
    <div className='flex items-center justify-end gap-2 pt-2 absolute bottom-[-2.25rem] right-0 group-hover:pointer-events-auto md:pointer-events-none hover:opacity-100 group-hover:opacity-100 md:opacity-0 transition-opacity duration-200'>
      <Tooltip content='Copy your answer'>
        <div
          className='w-7 h-7 rounded-sm bg-gray-100 flex items-center justify-center cursor-pointer'
          onClick={() => handleCopyAnswer(answer)}
        >
          <Copy className='w-5 h-5 text-body-300' />
        </div>
      </Tooltip>
      <Tooltip content='Edit your answer'>
        <div
          className='w-7 h-7 rounded-sm bg-gray-100 flex items-center justify-center cursor-pointer'
          onClick={() => handleEditAnswer(questionId, answer)}
        >
          <EditPencil className='w-5 h-5 text-body-300' />
        </div>
      </Tooltip>
    </div>
  );
};

export default EditAnswerOptions;
